import {BackgroundTextColor} from '@shared/model/background-text-color.interface';

export interface MultiSelectOption {
  value: any | any[];
  label: string;
  selected: boolean;
  color?: BackgroundTextColor;
  parent?: any;
  child?: MultiSelectOption[];
  allSelected?: boolean;
}
